import React from "react";

interface NoProductsFoundProps {
  fontClass: string;
}

const NoProductsFound: React.FC<NoProductsFoundProps> = ({ fontClass }) => {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1.5 mx-auto py-10 w-full justify-items-center ${fontClass}`}>
      <div className="col-span-full flex flex-col items-center text-center gap-3 p-4">
        <h3 className="text-lg sm:text-xl font-bold text-gray-700 mt-2 sm:mt-3">No Products Found</h3>
        <p className="text-gray-500 text-sm sm:text-base max-w-xs sm:max-w-sm">
          Looks like there are no products in this category. Try another category or adjust your search.
        </p>
      </div>
    </div>
  );
};

export default NoProductsFound;